import React from 'react';
import { withRouter } from 'react-router-dom';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

import { withAccount } from '../../../components/AccountContext';
import { withGrowl } from '../../../components/GrowlNotifications';
import UserInvitationForm from './UserInvitationForm';

const CREATE_USER_INVITATION = gql`
  mutation createJoinAccountInvitation($input: CreateJoinAccountInvitationInput!) {
    createJoinAccountInvitation(input: $input) {
      clientMutationId
    }
  }
`;

// https://codesandbox.io/s/apollo-and-react-hooks-4vril
// https://github.com/apollographql/react-apollo/tree/master/packages/hooks
function UserInvitationFormContainer({ children }) {
  const [createInvitationMutation, createInvitationResult] = useMutation(CREATE_USER_INVITATION, {
    refetchQueries: ['getAllJoinAccountInvitations'],
  });

  return children({
    createUserInvitation: { mutation: createInvitationMutation, result: createInvitationResult },
  });
}

const UserInvitationFormContainerWrapper = props => (
  <UserInvitationFormContainer>
    {({ createUserInvitation }) => <UserInvitationForm createUserInvitation={createUserInvitation} {...props} />}
  </UserInvitationFormContainer>
);

export default withRouter(withAccount(withGrowl(UserInvitationFormContainerWrapper)));
